import React from 'react';
import Classes from 'classnames';

type Props = {
    value?              : string
    size?               : string
    onChange?           : callback
    onFocus?            : callback
    onBlur?             : callback
    onKeyDown?          : callback
    isPassword?         : boolean
    placeholder?        : string
    className?          : string
    form?               : any
}

type State = {
    _isValid            : boolean
    _isRequired         : boolean
    _validators         : any[]
    _validationError    :  any
    _displayName        : string
    value               : string
}

export default class GDInput extends React.Component<Props, State> {

    // static propTypes = {
    //     size: PropTypes.string,
    //     onChange: PropTypes.func,
    //     onFocus: PropTypes.func,
    //     onBlur: PropTypes.func,
    //     isPassword: PropTypes.bool,
    //     placeholder: PropTypes.string,
    //     className: PropTypes.string
    // };

    static defaultProps = {
        size: 'normal',
        isPassword: false
    };

    public input = React.createRef<HTMLInputElement>();

    constructor(props: Props) {
        super(props);

        // this.displayName = 'GDSelect';
        // this.channels = ['','Very poor','Poor','Average','Good', 'Excellent'];

        let isRequired= false;
        let displayName    = "";
        let value   = "";

        if (this.props.placeholder) value = this.props.placeholder;
        if (this.props.value) value = this.props.value;

        // if (this.props.form) {
        //     const params = this.props.form.fields[this.props['form-field']];
        //     isRequired = params.required ? params.required : false;
        //     displayName = params.displayName ? params.displayName:gd.utils.strToTitleCase(this.props['form-field']);
        // }

        this.state = {
            _isValid            : true,
            _isRequired         : isRequired,
            _validators         : [],
            _validationError    : null,
            _displayName        : displayName,
            value               : value
        };
    }

    // UNSAFE_componentWillMount() {
    //     if (this.props.form) {
    //         this.validate(this.getValue());
    //         this.props.form.registerElement(this.props['form-field'],this);
    //     }
    // }

    // UNSAFE_componentWillReceiveProps(nextProps: any) {
    //     if (nextProps.value && nextProps.value !== this.props.value && nextProps.value !== this.stateValue) {
    //         this.setState({value:nextProps.value});
    //     }
    // }

    triggerOnChange = (changedValue: string)=> {
        // if (this.props.form) {
        //     this.props.form.onElementChange(this.props['form-field'],changedValue);
        // }

        if (this.props.onChange) {
            this.props.onChange(changedValue);
        }
    }

    getValue = ()=> {
        if (this.props.placeholder && this.state.value === this.props.placeholder) {
            return null;
        } else {
            return this.state.value;
        }
    }

    setValue = (newValue: string)=> {
        // this.state.value = newValue; // Experimentatl !
        this.setState({
            value: newValue
        })
    }

    validate = (curVal: any)=> {
        let isValid = true;
        let validationError = null;

        // first check required
        if (this.state._isRequired) {
            if (curVal === undefined || curVal === null || curVal.length<1) {
                isValid = false;
                validationError = this.state._displayName+" is required";
            }
            this.setState({
                _isValid: isValid,
                _validationError: validationError
            });
        }
    }

    focus = ()=> {
       this.input.current?.focus();
    }

    onInputChanged = (event: React.ChangeEvent<HTMLInputElement>)=> {
        const value = event.target.value;
        this.validate(value);
        this.setState({value: value},()=>{
            this.triggerOnChange(value);
        });
    }

    onFocus = ()=> {
        if (this.props.placeholder && this.state.value === this.props.placeholder) {
            this.setState({value: ''});
        }

        if (this.props.onFocus) this.props.onFocus();
    }

    onBlur = ()=> {
        if (this.props.placeholder && !this.state.value) {
            this.setState({value: this.props.placeholder});
        }

        if (this.props.onBlur) this.props.onBlur();
    }

    render() {
        const classes = Classes(this.props.className, {
            'gd-input': true,
            'default-value': this.state.value === this.props.placeholder,
            'invalid': this.props.form && this.props.form.displayErrors && this.state._isValid === false,
            'size-normal': this.props.size === 'normal',
            'size-big': this.props.size === 'big'
        });

        const inputType = !!this.props.isPassword ? "password" : "text";
        const value = this.state.value ? this.state.value : '';

        return (
            <input ref          = {this.input}
                   type         = {inputType}
                   className    = {classes}
                   value        = {value}
                   onChange     = {this.onInputChanged}
                   onKeyDown    = {this.props.onKeyDown}
                   onFocus      = {this.onFocus}
                   onBlur       = {this.onBlur}
                   placeholder  = {this.props.placeholder}/>
        );
    }
}
